import React from 'react';
import '../../App.css';
import Cards from '../Cards';
import Footer from '../Footer';
import HeroSection from '../HeroSection';
import { About1 } from '../About1';
import Contact from './Contact';
import Contact1 from './Contact1';
import GorillaTrekkingCard from './GorillaTrekkingCard';
import Card1 from './Card1';
import Productdet from './Productdet';
import Service1 from  './Service1'

function Home() {
  return (
    <>
      <HeroSection />
      {/* <Cards /> */}
      <Card1/>
      {/* <Productdet/> */}
      {/* <GorillaTrekkingCard/> */}
      <About1/>
      <Service1/>
     <Contact1/>
   
      
    </>
  );
}

export default Home;